// Simple toast notification system
export function showToast(message, type = 'success') {
  // Ensure we're in a browser environment
  if (typeof document === 'undefined') return;

  // Get or create toast container
  let container = document.getElementById('toast-container');
  if (!container) {
    container = document.createElement('div');
    container.id = 'toast-container';
    container.style.position = 'fixed';
    container.style.top = '20px';
    container.style.right = '20px';
    container.style.zIndex = '9999';
    document.body.appendChild(container);
  }

  // Create toast element
  const toast = document.createElement('div');
  toast.className = `toast toast-${type}`;
  toast.textContent = message;

  // Style the toast
  toast.style.padding = '1rem';
  toast.style.marginBottom = '0.5rem';
  toast.style.borderRadius = '4px';
  toast.style.boxShadow = '0 2px 4px rgba(0,0,0,0.2)';

  if (type === 'success') {
    toast.style.backgroundColor = '#2b8a3e';
    toast.style.color = 'white';
  } else if (type === 'error') {
    toast.style.backgroundColor = '#c92a2a';
    toast.style.color = 'white';
  } else if (type === 'warning') {
    toast.style.backgroundColor = '#e67700';
    toast.style.color = 'white';
  }

  // Add animation
  toast.style.animation = 'fadeIn 0.3s, fadeOut 0.5s 2.5s forwards';

  // Add to container
  container.appendChild(toast);

  // Remove after animation completes (3 seconds)
  setTimeout(() => {
    if (container.contains(toast)) {
      container.removeChild(toast);
    }
  }, 3000);
}

// Add the animation to the document if it doesn't exist
if (
  typeof document !== 'undefined' &&
  !document.getElementById('toast-animations')
) {
  const style = document.createElement('style');
  style.id = 'toast-animations';
  style.textContent = `
    @keyframes fadeIn {
      from { opacity: 0; transform: translateY(-20px); }
      to { opacity: 1; transform: translateY(0); }
    }
    @keyframes fadeOut {
      from { opacity: 1; transform: translateY(0); }
      to { opacity: 0; transform: translateY(-20px); }
    }
  `;
  document.head.appendChild(style);
}
